import { render, staticRenderFns } from "./ButtonsPage.vue?vue&type=template&id=6b90624a&"
import script from "./ButtonsPage.vue?vue&type=script&lang=js&"
export * from "./ButtonsPage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports